export const imageExtensions = [
    'jpg',
    'jpeg',
    'jfif',
    'jpe',
    'jif',
    'png',
    'gif',
    'bmp',
    'dib',
    'tiff',
    'tif',
    'webp',
    'heif',
    'heic',
    'raw',
    'psd',
    'exr',
    'ico',
    'pcx',
    'tga',
    'cr2',
    'cr3',
    'nef',
    'arw',
    'sr2',
    'srf',
    'orf',
    'rw2',
    'pef',
    'dng',
    'raf',
    'svg',
    'svgz',
    'ai',
    'eps',
    'cdr',
    'wmf',
    'emf',
    'hdr',
    'pic',
    'dcm',
    'fits',
    'xcf',
    'flif',
    'avif',
    'pct',
    'pict',
    'jbg',
    'jbig2',
];
export const videoExtensions = [
    'mp4',
    'avi',
    'mkv',
    'mov',
    'wmv',
    'flv',
    'webm',
    'prores',
    'dnxhd',
    'dnxhr',
    'mxf',
    'xavc',
    'cineform',
    'r3d',
    'braw',
    'ari',
    'crm',
    'mpg',
    'mpeg',
    'vob',
    'ts',
    '3gp',
    '3g2',
    'asf',
    'rm',
    'rmvb',
    'divx',
    'dat',
    'vcd',
    'yuv',
    'ffv1',
    'huffyuv',
];
export const audioExtensions = [
    'mp3',
    'aac',
    'm4a',
    'm4b',
    'm4p',
    'ogg',
    'oga',
    'opus',
    'wma',
    'flac',
    'alac',
    'wav',
    'aiff',
    'aif',
    'aifc',
    'dts',
    'ac3',
    'eac3',
    'thd',
    'amb',
    'bwf',
    'mid',
    'midi',
    'kar',
    'mod',
    's3m',
    'xm',
    'it',
    'amr',
    '3ga',
    'gsm',
    'spx',
    'ra',
    'rm',
    'ram',
    'voc',
    'au',
];
export const documentExtensions = [
    'txt',
    'rtf',
    'doc',
    'docx',
    'odt',
    'wps',
    'tex',
    'xls',
    'xlsx',
    'ods',
    'csv',
    'ppt',
    'pptx',
    'odp',
    'key',
    'pdf',
    'xps',
    'html',
    'htm',
    'xml',
    'epub',
    'mobi',
    'azw',
    'azw3',
];
